<img
	class="room-icon"
	*ngIf="iconPath"
	[src]="iconPath | resolveAsset"
	[style.filter]="filter ? filter : ''"
	[style.width]="width"
	[style.height]="height"
	alt="{{ altText }}" />
